/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description ListingAmenity
 */

export enum ListingAmenity {
  KNOWN = 0,
  ON_SITE_LAUNDRY = 1,
  AIR_CONDITIONING = 2,
  CEILING_FAN = 3,
  HIGH_CEILINGS = 4,
  ASSIGNED_PARKING = 5,
  FIREPLACE = 6,
  DISHWASHER = 7,
  BALCONY = 8,
  GARDEN = 9,
  DECK = 10,
  HARDWOOD_FLOOR = 11,
  CARPET = 12,
  FURNISHED = 13,
  CENTRAL_HEAT = 14,
  WALK_IN_CLOSETS = 15,
  IN_UNIT_LAUNDRY = 16,
  LEED_CERTIFIED = 17,
  LEED_SILVER = 18,
  LEED_GOLD = 19,
  LEED_PLATINUM = 20,
  EV_CHARGING = 21,
  WIFI = 22,
  KITCHEN = 23,
  TV = 24,
  CABLE = 25,
  WORKSPACE = 26,
  TILE_FLOOR = 27,
  MICROWAVE = 28,
  OVEN = 29,
  BRICK = 30,
  FREE_PARKING = 31,
  OUTDOOR_SPACE = 32,
  POOL = 33,
  FITNESS_CENTER = 34,
  COFFEE_TEA_MAKER = 35,
  TOILETRIES = 36,
  HOUSEKEEPING = 37,
  BREAKFAST_INCLUDED = 38,
  SMOKING_ALLOWED = 39,
  PRIVATE_POOL = 40,
  HEATED_INDOOR_POOL = 41,
  BEACH = 42,
  LAKE = 43,
  WATERFRONT = 44,
  MOUNTAINS = 45,
  OCEAN = 46,
  SKI_IN_SKI_OUT = 47,
  HOT_TUB = 48,
}

Object.defineProperty(ListingAmenity, '__ENUM_NAME', {
  value: 'ListingAmenity',
  writable: false,
  configurable: false,
  enumerable: false,
})
